<div class="cash-dialog">
  <div class="dialog-header">
    <div class="header-title">
      <mat-icon class="header-icon">point_of_sale</mat-icon>
      <div>
        <h2 mat-dialog-title class="title-text">Nouvelle session journalière</h2>
        <span class="subtitle-text">Comptez le fond de caisse : nombre de pièces et de billets, chiffres seuls</span>
      </div>
    </div>
    <button mat-icon-button type="button" (click)="cancel()" aria-label="Fermer" class="btn-close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    @if (data.label) {
      <div class="note" id="open-label">{{ data.label }}</div>
    }
    <app-cash-count-grid idPrefix="open-count" caption="Fond de caisse" [decimalComma]="true" (changed)="onCount($event)" (lastEnter)="focusSubmit()" />
    <form [formGroup]="form" (ngSubmit)="confirm()" id="openFloatForm">
      <mat-form-field appearance="outline" class="amount-field open-amount">
        <mat-label>Fond de caisse initial</mat-label>
        <input matInput appCents type="number" step="0.01" min="0" formControlName="amount" id="open-float" autocomplete="off" required (focus)="$any($event.target).select()" />
        <span matTextSuffix>&nbsp;€</span>
        @if (amount.hasError('amountCap')) {
          <mat-error>Au plus 999 999 999,99 €</mat-error>
        } @else if (amount.hasError('required')) {
          <mat-error>Comptez ou saisissez le fond de caisse (0 si vide)</mat-error>
        } @else if (amount.invalid) {
          <mat-error>Montant positif ou nul, deux décimales au plus</mat-error>
        }
      </mat-form-field>
    </form>
    @if (differs) {
      <div class="note open-differs">Saisi à la main : différent du comptage ({{ grid.total | currency:'EUR':'symbol':'1.2-2':'fr-FR' }})</div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-actions">
    <button mat-button type="button" (click)="cancel()" id="open-cancel">Annuler</button>
    <button mat-flat-button color="primary" type="submit" form="openFloatForm" [disabled]="!canConfirm" class="btn-submit" id="open-submit">
      <mat-icon>lock_open</mat-icon>
      <span>Démarrer la journée</span>
    </button>
  </mat-dialog-actions>
</div>
